export enum HvacModeType {
  Heating   = 0,
  Cooling  = 1,
  Auto  = 2,
  Mixed = 8,
  Unknown = 9
}
